import { authenticatedRequest } from './authApi';

const base = '/api/oracle';

export const getOracleStatus = () => authenticatedRequest(`${base}/status`, { method: 'GET' });
export const getOracleProfile = () => authenticatedRequest(`${base}/profile`, { method: 'GET' });
export const updateOracleProfile = (body) => authenticatedRequest(`${base}/profile`, { method: 'PUT', body });
export const getOracleToday = (locale) => authenticatedRequest(`${base}/today?locale=${encodeURIComponent(locale || 'es')}`, { method: 'GET' });
export const getOracleWeekly = (locale) => authenticatedRequest(`${base}/weekly?locale=${encodeURIComponent(locale || 'es')}`, { method: 'GET' });
export const askOracle = (question, locale, requestId) => authenticatedRequest(`${base}/ask`, { method: 'POST', body: { question, locale, ...(requestId ? { requestId } : {}) } });
